module.exports = __webpack_public_path__ + "static/media/west_ham.e357f497.png";